module.exports = __webpack_public_path__ + "img/resourceallocationfee-banner-jp.93ee737.png";